import React from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/logo.svg";
import instagram from "../assets/instagram.svg";
import twitter from "../assets/twitter.svg";
import facebook from "../assets/facebook.svg";

import {
  Container,
  SocialIcons,
  Top,
  Navigation,
  Bottom,
} from "../styles/footer";

const Footer = () => {
  return (
    <>
      <Container>
        <Top>
          <Link to="/">
            <img alt="" className="header-logo" src={Logo} width="100" />
          </Link>
          <Navigation>
            <Link to="/">Home</Link>
            <Link to="/about">About Us</Link>
            <Link to="/">Privacy Policy</Link>
          </Navigation>
          <SocialIcons>
            <a href="/">
              <img alt="instagram logo" src={instagram} />
            </a>
            <a href="/">
              <img alt="twitter logo" src={twitter} />
            </a>
            <a href="/">
              <img alt="facebook logo" src={facebook} />
            </a>
          </SocialIcons>
        </Top>
        <hr />
        <Bottom>
          <p>&copy;{new Date().getFullYear()} Aeydar. All rights reserved .</p>
        </Bottom>
      </Container>
    </>
  );
};

export default Footer;
